import ErrorWithToast from "./ErrorWithToast";

class LoginFail extends ErrorWithToast{
  constructor() {
    super("Verifique seu login e senha");
  }
}

export default LoginFail;